const mainAssessmentIds = {
  // main assessments
  ARBA: 'amplify_reading_benchmark_assessment',
  PLACEMENT_TOOL: 'placement_tool',
  SKILL_SCAN: 'skill_scan',
  SKILL_SCAN_AGGREGATE: 'skill_scan_aggregate',
  TRO: 'text_reading_online',
  TRO_BENCHMARK: 'tro_benchmark',
};

const submeasureIds = {
  // placement measures
  BLENDING_PLACEMENT: 'measure.blending',
  LETTER_SOUND_CORRESPONDENCES_PLACEMENT: 'measure.letter_sound_correspondences',
  MIND_THE_GAP_PLACEMENT: 'measure.mind_the_gap',
  REAL_WORD_READING_PLACEMENT: 'measure.real_word_reading',
  SEGMENTING_PLACEMENT: 'measure.segmenting',
  SYLLABLE_DECODING_PLACEMENT: 'measure.syllable_decoding',

  // skill scan measures
  BLENDING: 'blending',
  LETTER_SOUND_CORRESPONDENCES: 'letter_sound_correspondences',
  MIND_THE_GAP: 'mind_the_gap',
  REAL_WORD_READING: 'real_word_reading',
  SEGMENTING: 'segmenting',
  SYLLABLE_DECODING: 'syllable_decoding',
};

const assessmentIds = { ...mainAssessmentIds, ...submeasureIds };

// Set of all game ids for main assessments only for Reading and Lectura
export const MAIN_ASSESSMENT_IDS = new Set(Object.values(mainAssessmentIds)
  .flatMap(assessment => [assessment, `${assessment}_es`]));

// Set of all game ids for all assessments and submeasures for Reading and Lectura
export const ASSESSMENT_IDS = new Set(Object.values(assessmentIds)
  .flatMap(assessment => [assessment, `${assessment}_es`]));

export default assessmentIds;
